import { ActionIcon } from "rizzui/action-icon";
import { Text } from "rizzui/typography";
import CloseIcon from "../assets/close";
import { useDrawer } from "../hooks/useDrawer";
import { Box } from "rizzui/box";
import formatDate from "../lib/utils/formatDate";
import CallRecording from "./recording";
import {
  useCallDetails,
  useCallProviderDetails,
} from "../hooks/useCallDetails";
import MyLoader from "./loader";

export default function AppointmentDrawer({ event }) {
  const { closeDrawer } = useDrawer();

  const { data: callData, isLoading: callLoading } = useCallDetails({
    id: event?.call_id,
    location: "calls",
  });
  const { data: providerData, isLoading } = useCallProviderDetails({
    id: callData?.call_platform_id,
  });
  return (
    <div className="dark:bg-[#2A2C30] text-primary-dark flex flex-col justify-start gap-[16px] md:gap-[32px] backdrop-blur-lg h-screen p-[20px] !pb-[10px]">
      <ActionIcon
        variant="text"
        onClick={closeDrawer}
        className={"text-primary-dark p-0"}
        rounded="full"
      >
        <CloseIcon className={"text-primary-dark"} />
      </ActionIcon>

      <div>
        <Text className="font-ibmPlexSerif text-[18px] leading-[23.4px] font-[600]">
          Appointment details
        </Text>
      </div>

      <div className="min-h-[517px] h-auto flex flex-col gap-[40px] ">
        <div className="w-full flex flex-col h-[179px] border-[.5px] dark:bg-[#333F48] dark:border-0 rounded-[8px] border-[#D9D9D9] justify-center items-center gap-[10px]">
          <Box className="bg-[#D9D9D9] rounded-full h-[72px] w-[72px]" />
          <div className="flex flex-col gap-[11px]">
            <Text className="font-switzer text-center font-[500] text-[18px] leading-[23.76px]">
              {event?.lead_details?.firstname} {event?.lead_details?.lastname}
            </Text>
            <Text className="font-switzer text-center font-[400] text-[14px] leading-[15.84px]">
              {event?.lead_details?.email}
            </Text>
            <Text className="font-switzer text-center font-[400] text-[14px] leading-[15.84px]">
              {event?.lead_details?.phone_number}
            </Text>
          </div>
        </div>
        {!isLoading && !callLoading ? (
          <div className="flex flex-col gap-[24px]">
            <div className="flex flex-row justify-between">
              <Text className="font-switzer font-[500] text-[14px] leading-[18.48px]">
                Campaign
              </Text>
              <Text className="font-switzer font-[400] dark:text-[#758599] text-[12px] leading-[15.84px]">
                {event?.campaign?.name}
              </Text>
            </div>

            <div className="flex flex-row justify-between">
              <Text className="font-switzer font-[500] text-[14px] leading-[18.48px]">
                Appointment Date
              </Text>
              <Text className="font-switzer font-[400] dark:text-[#758599] text-[12px] leading-[15.84px]">
                {formatDate(event?.data?.start)}
              </Text>
            </div>

            <Box className="flex flex-col gap-[8px]">
              <Text className="font-switzer font-[500] text-[14px] leading-[18.48px]">
                Call summary
              </Text>
              <Text className="font-switzer font-[400] dark:text-[#758599] text-[12px] leading-[15.84px]">
                {providerData?.summary || "Call summary is not available."}
              </Text>
            </Box>

            <Box className="flex flex-col gap-[16px]">
              <Text className="font-switzer font-[500] text-[14px] leading-[18.48px]">
                Recording
              </Text>
              {callData?.recording_url ? (
                <CallRecording recordingUrl={callData?.recording_url} />
              ) : (
                <Text className="font-switzer font-[400] dark:text-[#758599] text-[12px] leading-[15.84px]">
                  Call recording is not available
                </Text>
              )}
            </Box>
          </div>
        ) : (
          <MyLoader />
        )}
      </div>
    </div>
  );
}
